<template>
  <div>
    <!-- Header compacto con botones -->
    <div class="card-body py-2">
      <div
        class="d-flex justify-content-between align-items-center flex-wrap gap-2"
      >
        <div class="d-flex align-items-center">
          <!-- <div class="ml-2">
            <h4 class="mb-0 fw-bold text-dark" style="font-size: 1.1rem;">
              Últimas Novedades
            </h4>
            <p class="text-muted mb-0" style="font-size: 0.75rem;">
              Monitoreo en tiempo real de eventos vehiculares
            </p>
          </div> -->
        </div>
        <div class="float-end">
          <button
            class="btn btn-sm position-relative"
            :class="
              sonidoActivo && audioHabilitado
                ? 'btn-dark'
                : 'btn-outline-secondary'
            "
            @click="toggleSonido"
            :title="
              sonidoActivo
                ? audioHabilitado
                  ? 'Sonido activado'
                  : 'Clic para activar sonido'
                : 'Sonido desactivado'
            "
          >
            <i
              class="fas"
              :class="
                sonidoActivo && audioHabilitado
                  ? 'fa-volume-up'
                  : 'fa-volume-mute'
              "
            ></i>
            <span
              v-if="sonidoActivo && !audioHabilitado"
              class="badge bg-warning position-absolute top-0 start-100 translate-middle"
              style="font-size: 0.6rem;"
              >!</span
            >
          </button>

          <button
            type="button"
            class="btn btn-sm"
            :class="tiempoRealActivo ? 'btn-danger' : 'btn-outline-danger'"
            @click="verEnTiempoReal"
            :disabled="cargando || filtrandoPorViaje"
            :title="
              filtrandoPorViaje
                ? 'No disponible al filtrar por viaje'
                : tiempoRealActivo
                ? 'Detener actualización automática'
                : 'Activar actualización automática cada 1 minuto'
            "
          >
            <i
              class="fas"
              :class="tiempoRealActivo ? 'fa-stop' : 'fa-play'"
            ></i>
            <span class="d-none d-md-inline ml-1">{{
              tiempoRealActivo ? "Detener" : "Tiempo Real"
            }}</span>
          </button>

          <button
            class="btn btn-success btn-sm"
            @click="abrirModalExportar"
            title="Exportar a Excel"
          >
            <i class="fas fa-file-excel"></i>
            <span class="d-none d-md-inline ml-1">Exportar</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Mensaje de Tiempo Real Activo compacto -->
    <div v-if="tiempoRealActivo" class="px-3 py-2">
      <div class="alert alert-info py-2 mb-0">
        <div class="d-flex align-items-center">
          <i class="fas fa-play-circle"></i>
          <strong class="ml-2">Tiempo Real Activado</strong>
          <small class="text-muted ml-2">
            Mostrando novedades de los últimos 20 minutos. Los filtros están
            ocultos.
          </small>
        </div>
      </div>
    </div>

    <!-- Filtros Bootstrap (ocultos en tiempo real) -->
    <div v-if="!tiempoRealActivo" class="card mb-4">
      <div
        class="card-header bg-gradient"
        style="background: linear-gradient(135deg, #b10000 0%, #505050 100%); cursor: pointer;"
        @click="mostrarFiltros = !mostrarFiltros"
      >
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <div class="bg-white bg-opacity-20 rounded-circle px-2 py-1">
              <i class="fas fa-filter mt-1"></i>
            </div>
            <div>
              <h5 class="mb-1 fw-bold text-white ml-2">Filtros de Búsqueda</h5>
              <p class="mb-0 small text-white-50 ml-2">
                Personaliza tu búsqueda de novedades
              </p>
            </div>
          </div>
          <div class="bg-white bg-opacity-20 rounded-circle px-2 py-1">
            <i
              class="fas"
              :class="mostrarFiltros ? 'fa-chevron-up' : 'fa-chevron-down'"
            ></i>
          </div>
        </div>
      </div>

      <transition name="fade">
        <div v-show="mostrarFiltros" class="card-body bg-light">
          <div class="row g-3 mb-4">
            <!-- Tipo Novedad -->
            <div class="col-md-6 col-lg-4">
              <div class="card h-100">
                <div class="card-body">
                  <label class="form-label d-flex align-items-center mb-2">
                    <div
                      class="bg-warning text-white rounded-circle p-1 me-2"
                      style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;"
                    >
                      <i
                        class="fas fa-exclamation-triangle"
                        style="font-size: 0.75rem;"
                      ></i>
                    </div>
                    <span class="fw-semibold ml-1">Tipo de Novedad</span>
                  </label>
                  <v-select
                    v-model="filtros.tipo_novedad"
                    :options="listasForms.tiposNovedad"
                    label="nombre"
                    :reduce="(tipo) => tipo.id"
                    placeholder="Seleccionar tipo..."
                    clearable
                    class="form-select"
                  />
                </div>
              </div>
            </div>
            <!-- Relevancia -->
            <div class="col-md-6 col-lg-4">
              <div class="card h-100">
                <div class="card-body">
                  <label class="form-label d-flex align-items-center mb-2">
                    <div
                      class="bg-info text-white rounded-circle p-1 me-2"
                      style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;"
                    >
                      <i class="fas fa-signal" style="font-size: 0.75rem;"></i>
                    </div>
                    <span class="fw-semibold ml-1">Nivel de Relevancia</span>
                  </label>
                  <v-select
                    v-model="filtros.relevancia"
                    :options="listasForms.relevancias"
                    label="nombre"
                    :reduce="(relevancia) => relevancia.id"
                    placeholder="Seleccionar relevancia..."
                    clearable
                    class="form-select"
                  />
                </div>
              </div>
            </div>
            <!-- Estado de Gestión -->
            <div class="col-md-6 col-lg-4">
              <div class="card h-100">
                <div class="card-body">
                  <label class="form-label d-flex align-items-center mb-2">
                    <div
                      class="bg-success text-white rounded-circle p-1 me-2"
                      style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;"
                    >
                      <i
                        class="fas fa-check-circle"
                        style="font-size: 0.75rem;"
                      ></i>
                    </div>
                    <span class="fw-semibold ml-1">Estado de Gestión</span>
                  </label>
                  <v-select
                    v-model="filtros.estado"
                    :options="listasForms.estadosGestion"
                    label="nombre"
                    :reduce="(estado) => estado.id"
                    placeholder="Seleccionar estado..."
                    clearable
                    class="form-select"
                  />
                </div>
              </div>
            </div>
            <!-- Cantidad por Página -->
            <div class="col-md-6 col-lg-4">
              <div class="card h-100">
                <div class="card-body">
                  <label class="form-label d-flex align-items-center mb-2">
                    <div
                      class="bg-primary text-white rounded-circle p-1 me-2"
                      style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;"
                    >
                      <i class="fas fa-list-ol" style="font-size: 0.75rem;"></i>
                    </div>
                    <span class="fw-semibold ml-1">Cantidad por Página</span>
                  </label>
                  <v-select
                    v-model="filtros.per_page"
                    :options="[
                      { value: 10, label: '10 registros' },
                      { value: 25, label: '25 registros' },
                      { value: 50, label: '50 registros' },
                      { value: 100, label: '100 registros' },
                    ]"
                    label="label"
                    :reduce="(option) => option.value"
                    placeholder="Seleccionar cantidad..."
                    class="form-select  "
                    @input="onCantidadChange"
                  />
                </div>
              </div>
            </div>
            <!-- Tipo de Filtro -->
            <div class="col-md-6 col-lg-4">
              <div class="card h-100">
                <div class="card-body">
                  <label class="form-label d-flex align-items-center mb-2">
                    <div
                      class="bg-primary text-white rounded-circle p-1 me-2"
                      style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;"
                    >
                      <i class="fas fa-filter" style="font-size: 0.75rem;"></i>
                    </div>
                    <span class="fw-semibold ml-1">Tipo de Filtro</span>
                  </label>
                  <v-select
                    v-model="filtros.tipo_filtro"
                    :options="[
                      { value: 'viaje', label: 'Viaje' },
                      { value: 'postulacion', label: 'Postulación' },
                    ]"
                    label="label"
                    :reduce="(option) => option.value"
                    placeholder="Seleccionar tipo..."
                    clearable
                    class="form-select"
                    @input="onTipoFiltroChange"
                  />
                </div>
              </div>
            </div>
            <!-- ID del Viaje -->
            <div
              class="col-md-6 col-lg-4"
              v-if="filtros.tipo_filtro === 'viaje'"
            >
              <div class="card h-100">
                <div class="card-body">
                  <label class="form-label d-flex align-items-center mb-2">
                    <div
                      class="bg-primary text-white rounded-circle p-1 me-2"
                      style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;"
                    >
                      <i class="fas fa-route" style="font-size: 0.75rem;"></i>
                    </div>
                    <span class="fw-semibold ml-1">ID del Viaje</span>
                  </label>
                  <div class="input-group">
                    <span class="input-group-text bg-primary text-white">
                      <i class="fas fa-hashtag"></i>
                    </span>
                    <input
                      type="number"
                      class="form-control form-control-sm"
                      v-model="filtros.viaje_id"
                      placeholder="Ej: 12345"
                      @input="onViajeChange"
                    />
                  </div>
                  <div class="form-text d-flex align-items-center">
                    <i class="fas fa-info-circle text-info me-1"></i>
                    <span class="small"
                      >Mostrando TODAS las novedades del viaje (gestionadas y no
                      gestionadas)</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- ID de la Postulación -->
            <div
              class="col-md-6 col-lg-4"
              v-if="filtros.tipo_filtro === 'postulacion'"
            >
              <div class="card h-100">
                <div class="card-body">
                  <label class="form-label d-flex align-items-center mb-2">
                    <div
                      class="bg-success text-white rounded-circle p-1 me-2"
                      style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;"
                    >
                      <i
                        class="fas fa-file-alt"
                        style="font-size: 0.75rem;"
                      ></i>
                    </div>
                    <span class="fw-semibold ml-1">ID de la Postulación</span>
                  </label>
                  <div class="input-group">
                    <span class="input-group-text bg-success text-white">
                      <i class="fas fa-hashtag"></i>
                    </span>
                    <input
                      type="number"
                      class="form-control form-control-sm"
                      v-model="filtros.det_postulacion_id"
                      placeholder="Ej: 67890"
                      @input="onPostulacionChange"
                    />
                  </div>
                  <div class="form-text d-flex align-items-center">
                    <i class="fas fa-info-circle text-info me-1"></i>
                    <span class="small"
                      >Mostrando TODAS las novedades de la postulación
                      (gestionadas y no gestionadas)</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- Fecha -->
            <div class="col-md-6 col-lg-4">
              <div class="card h-100">
                <div class="card-body">
                  <label class="form-label d-flex align-items-center mb-2">
                    <div
                      class="bg-success text-white rounded-circle p-1 me-2"
                      style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;"
                    >
                      <i
                        class="fas fa-calendar-alt"
                        style="font-size: 0.75rem;"
                      ></i>
                    </div>
                    <span class="fw-semibold ml-1">Fecha</span>
                  </label>
                  <div class="row ml-1">
                    <input
                      type="date"
                      v-model="filtros.fecha"
                      style="font-size: 13px"
                      class="form-control form-control-sm col-md-6"
                      :max="fechaMaxima"
                      :disabled="filtrandoPorViaje || filtrandoPorPostulacion"
                    />
                    <input
                      v-model="filtros.hora_inicial"
                      type="text"
                      class="form-control form-control-sm col-md-6"
                      style="font-size: 13px"
                      v-mask="{
                        mask: '99:99',
                        hourFormat: '24',
                      }"
                      :disabled="filtrandoPorViaje || filtrandoPorPostulacion"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Botones de acción rápida -->
          <div class="card">
            <div class="card-body">
              <h6 class="card-title d-flex align-items-center mb-3">
                <div
                  class="bg-light textrounded-circle p-1 me-2 border border-dark"
                  style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;"
                >
                  <i class="fas fa-bolt text-warning m-2"></i>
                </div>
                <strong class="ml-1">Acciones Rápidas</strong>
              </h6>
              <div class="d-flex flex-wrap gap-2 justify-content-center">
                <button
                  type="button"
                  class="btn btn-outline-primary px-3"
                  @click="buscarNovedades"
                  :disabled="cargando || tiempoRealActivo"
                >
                  <i
                    class="fas fa-search me-2"
                    :class="cargando ? 'fa-spin' : ''"
                  ></i>
                  {{ cargando ? "Buscando..." : "Buscar Novedades" }}
                </button>

                <button
                  type="button"
                  class="btn btn-outline-danger"
                  @click="limpiarFiltros"
                  :disabled="cargando || tiempoRealActivo"
                >
                  <i class="fas fa-eraser me-1"></i>
                  Limpiar
                </button>

                <button
                  type="button"
                  class="btn btn-outline-success"
                  @click="aplicarFiltroRapido('hoy')"
                  :disabled="cargando || tiempoRealActivo"
                >
                  <i class="fas fa-calendar me-1"></i>
                  Hoy
                </button>
                <button
                  type="button"
                  class="btn btn-outline-info"
                  @click="aplicarFiltroRapido('ultimaHora')"
                  :disabled="cargando || tiempoRealActivo"
                >
                  <i class="fas fa-clock me-1"></i>
                  Última Hora
                </button>
                <button
                  type="button"
                  class="btn btn-outline-warning"
                  @click="aplicarFiltroRapido('emergencias')"
                  :disabled="cargando || tiempoRealActivo"
                >
                  <i class="fas fa-exclamation-triangle me-1"></i>
                  Solo Emergencias
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- Contenido principal -->
    <div class="row g-2 pt-2">
      <!-- Mapa -->
      <div class="col-12 col-lg-8">
        <div class="card shadow-sm h-100" v-if="!cargando">
          <div class="card-body p-0 position-relative">
            <div
              v-if="cargandoMapa"
              class="text-center p-3"
              style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 1000;"
            >
              <i class="fas fa-spinner fa-spin fa-2x text-muted"></i>
              <p class="mt-2 text-muted small">Cargando mapa...</p>
            </div>
            <gmap-map
              v-if="!cargandoMapa"
              ref="mapRef"
              class="w-100 border border-default"
              style="height: 600px; min-height: 300px;"
              :center="mapCenter"
              :zoom="mapZoom"
              :options="mapOptions"
              @click="onMapClick"
            >
              <gmap-marker
                v-for="(marker, index) in markersNovedades"
                :key="index"
                :position="marker.position"
                :icon="marker.icon"
                :clickable="true"
                @click="toggleInfoWindow(marker, index)"
              ></gmap-marker>

              <gmap-info-window
                :options="infoWindowOptions"
                :position="infoWindowPosition"
                :opened="infoWindowOpen"
                @closeclick="infoWindowOpen = false"
              >
                <div v-html="infoWindowContent"></div>
              </gmap-info-window>
            </gmap-map>
          </div>
        </div>
      </div>
      <!-- Panel de Novedades Compacto -->
      <div class="col-12 col-lg-4">
        <div class="card shadow-sm h-100">
          <div class="card-header bg-gradient-primary text-white py-2">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <i class="fas fa-bell me-2"></i>
                <h6 class="mb-0">Novedades</h6>
              </div>
              <span
                class="badge bg-white text-primary px-2 py-1"
                v-if="novedades.length"
                >Total:
                {{ novedades.length }}
              </span>
            </div>
          </div>
          <div
            class="card-body p-0"
            style="max-height: 500px; overflow-y: auto;"
          >
            <div v-if="cargando" class="text-center p-3">
              <div class="mb-2">
                <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
              </div>
              <h6 class="text-muted mb-1" style="font-size: 0.85rem;">
                Cargando novedades...
              </h6>
              <small class="text-muted" style="font-size: 0.7rem;">
                Buscando información en tiempo real
              </small>
            </div>
            <div v-else-if="novedades.length === 0" class="text-center p-3">
              <div class="mb-2">
                <i class="fas fa-bell-slash fa-2x text-muted"></i>
              </div>
              <h6 class="text-muted mb-1" style="font-size: 0.85rem;">
                No hay novedades
              </h6>
              <small class="text-muted" style="font-size: 0.7rem;">
                No se encontraron novedades con los filtros aplicados
              </small>
              <div class="mt-2">
                <button
                  class="btn btn-outline-primary btn-sm"
                  @click="limpiarFiltros"
                  style="font-size: 0.75rem;"
                >
                  <i class="fas fa-eraser me-1"></i>
                  Limpiar Filtros
                </button>
              </div>
            </div>
            <div class="p-2" v-else>
              <div
                v-for="novedad in novedades"
                :key="novedad.id"
                class="border rounded mb-2 p-2 position-relative shadow-sm"
                style="cursor: pointer; transition: all 0.2s ease;"
                @click="seleccionarNovedad(novedad)"
                :class="{
                  'border-primary bg-light':
                    novedadSeleccionada &&
                    novedadSeleccionada.id === novedad.id,
                  'border-default': !(
                    novedadSeleccionada && novedadSeleccionada.id === novedad.id
                  ),
                }"
              >
                <!-- Header compacto -->
                <div class="d-flex align-items-center mb-2">
                  <div
                    class="rounded-circle d-flex align-items-center justify-content-center me-2"
                    style="width: 28px; height: 28px;"
                    :class="{
                      'bg-warning text-white': novedad.relevancia === 1,
                      'bg-danger text-white': novedad.relevancia === 2,
                      'bg-info text-white': novedad.relevancia === 3,
                      'bg-secondary text-white': !novedad.relevancia,
                    }"
                  >
                    <i
                      class="fas"
                      :class="getNovedadIcon(novedad.tipo_novedad)"
                      style="font-size: 0.75rem;"
                    ></i>
                  </div>
                  <div class="flex-grow-1">
                    <h6
                      class="mb-0 fw-bold text-dark ml-1"
                      style="font-size: 0.85rem;"
                    >
                      {{ novedad.nTipoNovedad || "N/A" }}
                    </h6>
                    <small class="text-muted ml-1" style="font-size: 0.7rem;">
                      <i class="far fa-clock me-1"></i>
                      {{ formatFecha(novedad.fecha_novedad) }}
                    </small>
                  </div>
                  <span
                    class="badge"
                    :class="getRelevanciaColor(novedad.relevancia)"
                    style="font-size: 0.65rem;"
                  >
                    {{ novedad.nRelevancia || "N/A" }}
                  </span>
                </div>

                <!-- Información compacta en grid -->
                <div class="row g-1 mb-2">
                  <div class="col-6">
                    <div class="d-flex align-items-center">
                      <i
                        class="fas fa-truck text-primary me-1"
                        style="font-size: 0.7rem;"
                      ></i>
                      <span
                        class="text-muted small ml-1"
                        style="font-size: 0.7rem;"
                        >Vh:</span
                      >
                      <strong class="ml-1" style="font-size: 0.7rem;">{{
                        getPlacaVehiculo(novedad)
                      }}</strong>
                    </div>
                  </div>
                  <div class="col-6" v-if="getRemolque(novedad)">
                    <div class="d-flex align-items-center">
                      <i
                        class="fas fa-trailer text-warning"
                        style="font-size: 0.7rem;"
                      ></i>
                      <span
                        class="text-muted small ml-1"
                        style="font-size: 0.7rem;"
                        >Rem:</span
                      >
                      <strong class="ml-1" style="font-size: 0.7rem;">{{
                        getRemolque(novedad) || "N/A"
                      }}</strong>
                    </div>
                  </div>
                  <div class="col-6" v-if="novedad.velocidad">
                    <div class="d-flex align-items-center">
                      <i
                        class="fas fa-tachometer-alt text-warning"
                        style="font-size: 0.7rem;"
                      ></i>
                      <span
                        class="text-muted small ml-1"
                        style="font-size: 0.7rem;"
                        >Vel:</span
                      >
                      <strong class="ml-1" style="font-size: 0.7rem;"
                        >{{ novedad.velocidad }} km/h</strong
                      >
                    </div>
                  </div>
                  <div class="col-6" v-if="getTipoSubNovedad(novedad)">
                    <div class="d-flex align-items-center">
                      <i
                        class="fas fa-tag text-muted me-1"
                        style="font-size: 0.7rem;"
                      ></i>
                      <span
                        class="badge bg-light text-dark"
                        style="font-size: 0.65rem;"
                        >{{ getTipoSubNovedad(novedad) }}</span
                      >
                    </div>
                  </div>
                </div>

                <!-- Conductor compacto -->
                <div
                  class="bg-light border border-default p-2 rounded mb-2"
                  v-if="getConductor(novedad)"
                >
                  <div
                    class="d-flex align-items-center justify-content-center mb-1"
                  >
                    <i
                      class="fas fa-user text-info"
                      style="font-size: 0.7rem;"
                    ></i>
                    <strong
                      class="text-dark ml-1"
                      style="font-size: 0.75rem;"
                      >{{ getConductor(novedad) }}</strong
                    >
                  </div>
                  <div class="row g-1">
                    <div class="col-6 d-flex align-items-center">
                      <i class="fas fa-id-card"></i>
                      <small
                        class="text-muted ml-1"
                        style="font-size: 0.65rem;"
                      >
                        {{ getConductorDocumento(novedad) || "N/A" }}
                      </small>
                    </div>
                    <div class="col-6 d-flex align-items-center">
                      <i class="fas fa-phone"></i>
                      <small
                        class="text-muted ml-1"
                        style="font-size: 0.65rem;"
                      >
                        {{ getConductorCelular(novedad) || "N/A" }}
                      </small>
                    </div>
                  </div>
                </div>

                <!-- Ubicación compacta -->
                <div
                  class="alert-default-warning border border-default bg-opacity-10 p-2 rounded"
                  v-if="novedad.latitud && novedad.longitud"
                >
                  <div class="d-flex align-items-center mb-1">
                    <i
                      class="fas fa-map-marker-alt text-danger me-1"
                      style="font-size: 0.7rem;"
                    ></i>
                    <span
                      class="text-muted small ml-1"
                      style="font-size: 0.7rem;"
                      >Ubicación</span
                    >
                  </div>
                  <div class="row g-1">
                    <div class="col-6">
                      <small
                        class="badge bg-light text-dark w-100 text-center"
                        style="font-size: 0.6rem;"
                      >
                        Lat: {{ parseFloat(novedad.latitud).toFixed(3) }}
                      </small>
                    </div>
                    <div class="col-6">
                      <small
                        class="badge bg-light text-dark w-100 text-center"
                        style="font-size: 0.6rem;"
                      >
                        Lng: {{ parseFloat(novedad.longitud).toFixed(3) }}
                      </small>
                    </div>
                  </div>
                  <div class="mt-1" v-if="novedad.direccion">
                    <small class="text-muted" style="font-size: 0.65rem;">
                      <i class="fas fa-road"></i>
                      {{
                        novedad.direccion.length > 30
                          ? novedad.direccion.substring(0, 30) + "..."
                          : novedad.direccion
                      }}
                    </small>
                  </div>
                  <div
                    class="mt-1"
                    v-if="
                      novedad.det_tramo_ruta &&
                        novedad.det_tramo_ruta.tramo_ruta
                    "
                  >
                    <small class="text-muted" style="font-size: 0.65rem;">
                      <i class="fas fa-route"></i>
                      Tramo: {{ novedad.det_tramo_ruta.tramo_ruta.nombre }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Tabla de Novedades compacta -->
    <div class="card mb-0 mt-2 border border-default">
      <div class="card-header bg-default text-dark py-2">
        <h6 class="mb-0" style="font-size: 0.9rem;">
          <i class="fas fa-table me-2"></i>
          Tabla de Novedades
        </h6>
      </div>
      <div class="card-body p-0">
        <div v-if="cargando" class="text-center p-3">
          <div class="mb-2">
            <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
          </div>
          <h6 class="text-muted mb-1" style="font-size: 0.85rem;">
            Cargando novedades...
          </h6>
          <small class="text-muted" style="font-size: 0.7rem;">
            Buscando información en tiempo real
          </small>
        </div>
        <div class="table-responsive" v-else>
          <table
            class="table table-striped table-hover mb-0 text-nowrap table-bordered"
          >
            <thead class="table-dark">
              <tr>
                <th class="text-center">#</th>
                <th>Tipo</th>
                <th>ID</th>
                <th># Programación</th>
                <th>Transportadora</th>
                <th>Vehículo</th>
                <th>Conductor</th>
                <th>Remolque</th>
                <th>Tipo Novedad</th>
                <th>Subnovedad</th>
                <th>Relevancia</th>
                <th>Sitio Cargue</th>
                <th>Sitio Descargue</th>
                <th>Fecha Novedad</th>
                <th>Fecha Cargue</th>
                <th>Fecha Descargue</th>
                <th>Ubicación</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(novedad, index) in novedadesPag.data"
                :key="novedad.id"
                class="align-middle"
              >
                <td class="text-center">
                  <span class="badge bg-secondary">{{ index + 1 }}</span>
                </td>
                <td>
                  <span
                    class="badge"
                    :class="novedad.viaje_id ? 'bg-primary' : 'bg-success'"
                  >
                    {{ novedad.viaje_id ? "Viaje" : "Postulación" }}
                  </span>
                </td>
                <td>
                  <strong class="text-primary">{{
                    novedad.viaje_id || novedad.det_postulacion_id || "N/A"
                  }}</strong>
                </td>
                <td class="d-flex align-items-center">
                  {{
                    (novedad.viaje && novedad.viaje.zafiro_id) ||
                      (novedad.det_postulacion &&
                        novedad.det_postulacion.zafiro_id) ||
                      "Sin programación"
                  }}
                </td>
                <td>
                  {{ getEmpresa(novedad) }}
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span>{{ getPlacaVehiculo(novedad) }}</span>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span>{{ getConductor(novedad) }}</span>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span>{{ getRemolque(novedad) || "N/A" }}</span>
                  </div>
                </td>
                <td>
                  <span class="fw-semibold">{{
                    novedad.nTipoNovedad || "N/A"
                  }}</span>
                </td>
                <td>
                  <span class="badge bg-light text-dark">{{
                    getTipoSubNovedad(novedad) || "N/A"
                  }}</span>
                </td>
                <td>
                  <span
                    class="badge"
                    :class="getRelevanciaColor(novedad.relevancia)"
                  >
                    {{ novedad.nRelevancia || "N/A" }}
                  </span>
                </td>
                <td>
                  <small class="text-muted">{{
                    getSitioCargue(novedad)
                  }}</small>
                </td>
                <td>
                  <small class="text-muted">{{
                    getSitioDescargue(novedad)
                  }}</small>
                </td>
                <td>
                  <small class="text-muted">{{ novedad.fecha_novedad }}</small>
                </td>
                <td>
                  <small class="text-muted">{{
                    (novedad.viaje &&
                      novedad.viaje.trazas_fechas_viaje &&
                      novedad.viaje.trazas_fechas_viaje.fecha_cargue) ||
                      "Sin fecha de cargue"
                  }}</small>
                </td>
                <td>
                  <small class="text-muted">{{
                    (novedad.viaje &&
                      novedad.viaje.trazas_fechas_viaje &&
                      novedad.viaje.trazas_fechas_viaje.fecha_descargue) ||
                      "Sin fecha de descargue"
                  }}</small>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <i class="fas fa-map-marker-alt text-danger"></i>
                    <small class="text-muted ml-1">{{
                      novedad.direccion || "Sin dirección"
                    }}</small>
                  </div>
                </td>
                <td>
                  <span
                    class="badge"
                    :class="{
                      'bg-success': getEstadoNovedad(novedad) === 'Gestionada',
                      'bg-warning': getEstadoNovedad(novedad) === 'En proceso',
                      'bg-danger':
                        getEstadoNovedad(novedad) === 'Sin gestionar',
                    }"
                  >
                    {{ getEstadoNovedad(novedad) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Paginación compacta -->
      <div class="card-footer bg-light pb-0" v-if="!cargando">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div
              v-if="novedadesPag.total"
              class="text-muted"
              style="font-size: 0.8rem;"
            >
              <i class="fas fa-info-circle me-1"></i>
              Mostrando del <strong>{{ novedadesPag.from }}</strong> al
              <strong>{{ novedadesPag.to }}</strong> de un total:
              <strong>{{ novedadesPag.total }}</strong> Registros
            </div>
            <div v-else>
              <span class="badge bg-danger" style="font-size: 0.75rem;">
                <i class="fas fa-exclamation-triangle me-1"></i>
                No hay registros para mostrar
              </span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-flex justify-content-end">
              <pagination
                :data="novedadesPag"
                @pagination-change-page="getIndex"
                :limit="5"
                class="float-right"
              ></pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Exportar -->
    <div class="modal fade" tabindex="-1" id="modalExportar">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content border-0 shadow-lg">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">
              Exportar Novedades
            </h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              ref="modalExportar"
              id="close-modal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-4">
            <div class="row g-3">
              <div class="col-md-6">
                <div class="card h-100">
                  <div class="card-body">
                    <label class="form-label d-flex align-items-center mb-3">
                      <span class="fw-semibold">Fecha Inicial</span>
                    </label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="filtrosExportar.fecha_inicial"
                      :max="fechaMaxima"
                      :class="
                        $v.filtrosExportar.fecha_inicial.$invalid
                          ? 'is-invalid'
                          : 'is-valid'
                      "
                      @blur="valFechasExportar"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card h-100">
                  <div class="card-body">
                    <label class="form-label d-flex align-items-center mb-3">
                      Fecha Final
                    </label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="filtrosExportar.fecha_final"
                      :max="fechaMaxima"
                      :class="
                        $v.filtrosExportar.fecha_final.$invalid
                          ? 'is-invalid'
                          : 'is-valid'
                      "
                      @blur="valFechasExportar"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row g-3 mt-2">
              <div class="col-md-6">
                <div class="card h-100">
                  <div class="card-body">
                    <label class="form-label d-flex align-items-center mb-3">
                      Tipo de Novedad
                    </label>
                    <v-select
                      v-model="filtrosExportar.tipo_novedad"
                      :options="listasForms.tiposNovedad"
                      label="nombre"
                      :reduce="(tipo) => tipo.id"
                      placeholder="Seleccionar tipo..."
                      class="form-select"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card h-100">
                  <div class="card-body">
                    <label class="form-label d-flex align-items-center mb-3">
                      Relevancia
                    </label>
                    <v-select
                      v-model="filtrosExportar.relevancia"
                      :options="listasForms.relevancias"
                      label="nombre"
                      :reduce="(relevancia) => relevancia.id"
                      placeholder="Seleccionar relevancia..."
                      class="form-select"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="modal-footer bg-light"
            v-if="!$v.filtrosExportar.$invalid"
          >
            <button
              type="button"
              class="btn btn-success"
              @click="exportarNovedades"
              :disabled="exportando"
            >
              <i
                class="fas me-1"
                :class="exportando ? 'fa-spinner fa-spin' : 'fa-file-excel'"
              ></i>
              {{ exportando ? "Exportando..." : "Exportar" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import pagination from "laravel-vue-pagination";
import { required } from "vuelidate/lib/validators";

export default {
  name: "UltimasNovedadesTab",
  components: {
    vSelect,
    pagination,
  },
  data() {
    return {
      cargando: false,
      cargandoMapa: false,
      novedades: [],
      novedadesPag: {},
      novedadSeleccionada: null,
      mostrarFiltros: true,
      tiempoRealActivo: false,
      sonidoActivo: false,
      audioHabilitado: false,
      exportando: false,

      // Filtros
      filtros: {
        tipo_novedad: null,
        relevancia: null,
        estado: null,
        per_page: 10,
        tipo_filtro: null,
        viaje_id: null,
        det_postulacion_id: null,
        fecha: null,
        hora_inicial: null,
      },

      filtrosExportar: {
        fecha_inicial: null,
        fecha_final: null,
        tipo_novedad: null,
        relevancia: null,
      },

      // Listas para formularios
      listasForms: {
        tiposNovedad: [],
        relevancias: [],
        subNovedades: [],
        estadosGestion: [],
      },

      // Mapa
      mapCenter: { lat: 4.6097, lng: -74.0817 }, // Bogotá por defecto
      mapZoom: 6,
      mapOptions: {
        styles: [
          {
            featureType: "poi",
            elementType: "labels",
            stylers: [{ visibility: "off" }],
          },
        ],
      },
      markersNovedades: [],
      infoWindowOpen: false,
      infoWindowPosition: null,
      infoWindowContent: "",
      infoWindowOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
        maxWidth: 360,
      },

      // Computed properties helpers
      fechaMaxima: moment().format("YYYY-MM-DD"),
    };
  },
  validations: {
    filtrosExportar: {
      fecha_inicial: {
        required,
      },
      fecha_final: {
        required,
      },
    },
  },

  computed: {
    // Computed properties para filtros
    filtrandoPorViaje() {
      return this.filtros.tipo_filtro === "viaje" && this.filtros.viaje_id;
    },
    filtrandoPorPostulacion() {
      return (
        this.filtros.tipo_filtro === "postulacion" &&
        this.filtros.det_postulacion_id
      );
    },
  },

  mounted() {
    this.cargarListas();
    this.getIndex();
    this.inicializarAudio();
    // Asegurar que el mapa se inicialice después de que el DOM esté listo
    this.$nextTick(() => {
      this.cargandoMapa = false;
    });
  },

  beforeDestroy() {
    if (this.tiempoRealActivo) {
      clearInterval(this.intervaloTiempoReal);
    }
  },

  methods: {
    // Métodos de carga de datos
    async getIndex(page = 1) {
      this.cargando = true;
      try {
        const params = {
          page,
          per_page: this.filtros.per_page,
          ...this.filtros,
        };

        const response = await axios.get(
          "/api/admin/centralTrafico/ultimasNovedades?page=" + page,
          {
            params,
          }
        );
        this.novedades = response.data.data;
        this.novedadesPag = response.data.paginado;
        this.actualizarMarcadoresMapa();
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "No se pudieron cargar las novedades",
        });
      } finally {
        this.cargando = false;
      }
    },

    async cargarListas() {
      try {
        const [
          tiposResponse,
          relevanciasResponse,
          subNovedadesResponse,
          estadosResponse,
        ] = await Promise.all([
          axios.get("/api/admin/centralTrafico/listaTiposNovedad"),
          axios.get("/api/admin/centralTrafico/listaRelevancias"),
          axios.get("/api/admin/centralTrafico/listaSubNovedades"),
          axios.get("/api/admin/centralTrafico/listaEstadosGestion"),
        ]);

        this.listasForms.tiposNovedad = tiposResponse.data.map((tipo) => ({
          id: tipo.id,
          nombre: tipo.nombre,
        }));

        this.listasForms.relevancias = relevanciasResponse.data.map(
          (relevancia) => ({
            id: relevancia.id,
            nombre: relevancia.nombre,
          })
        );

        this.listasForms.subNovedades = subNovedadesResponse.data.map(
          (sub) => ({
            id: sub.id,
            nombre: sub.nombre,
          })
        );

        this.listasForms.estadosGestion = estadosResponse.data.map(
          (estado) => ({
            id: estado.id,
            nombre: estado.nombre,
          })
        );
      } catch (error) {
        // Error al cargar listas - se maneja silenciosamente
      }
    },

    // Métodos de filtros
    buscarNovedades() {
      this.getIndex(1);
    },

    limpiarFiltros() {
      this.filtros = {
        tipo_novedad: null,
        relevancia: null,
        estado: null,
        per_page: 10,
        tipo_filtro: null,
        viaje_id: null,
        det_postulacion_id: null,
        fecha: null,
        hora_inicial: null,
      };
      this.getIndex(1);
    },

    aplicarFiltroRapido(tipo) {
      const hoy = moment().format("YYYY-MM-DD");
      const ahora = moment().format("HH:mm");

      switch (tipo) {
        case "hoy":
          this.filtros.fecha = hoy;
          this.filtros.hora_inicial = "00:00";
          break;
        case "ultimaHora":
          this.filtros.fecha = hoy;
          this.filtros.hora_inicial = moment()
            .subtract(1, "hour")
            .format("HH:mm");
          break;
        case "emergencias":
          this.filtros.relevancia = 2; // Asumiendo que 2 es emergencia
          break;
      }

      this.buscarNovedades();
    },

    onCantidadChange() {
      this.getIndex(1);
    },

    onTipoFiltroChange() {
      this.filtros.viaje_id = null;
      this.filtros.det_postulacion_id = null;
      this.filtros.fecha = null;
      this.filtros.hora_inicial = null;
    },

    onViajeChange() {
      if (this.filtros.viaje_id) {
        this.filtros.fecha = null;
        this.filtros.hora_inicial = null;
        this.buscarNovedades();
      }
    },

    onPostulacionChange() {
      if (this.filtros.det_postulacion_id) {
        this.filtros.fecha = null;
        this.filtros.hora_inicial = null;
        this.buscarNovedades();
      }
    },

    // Métodos de tiempo real
    verEnTiempoReal() {
      if (this.tiempoRealActivo) {
        this.detenerTiempoReal();
      } else {
        this.iniciarTiempoReal();
      }
    },

    iniciarTiempoReal() {
      this.tiempoRealActivo = true;
      this.mostrarFiltros = false;

      // Aplicar filtro de últimos 20 minutos
      const hace20Minutos = moment().subtract(20, "minutes");
      this.filtros.fecha = hace20Minutos.format("YYYY-MM-DD");
      this.filtros.hora_inicial = hace20Minutos.format("HH:mm");

      this.getIndex(1);

      // Actualizar cada minuto
      this.intervaloTiempoReal = setInterval(() => {
        this.getIndex(1);
      }, 60000);
    },

    detenerTiempoReal() {
      this.tiempoRealActivo = false;
      this.mostrarFiltros = true;

      if (this.intervaloTiempoReal) {
        clearInterval(this.intervaloTiempoReal);
      }

      // Limpiar filtros de tiempo real
      this.filtros.fecha = null;
      this.filtros.hora_inicial = null;
    },

    // Métodos de sonido
    inicializarAudio() {
      // Solicitar permisos de audio
      if (
        typeof AudioContext !== "undefined" ||
        typeof webkitAudioContext !== "undefined"
      ) {
        this.audioHabilitado = true;
      }
    },

    toggleSonido() {
      if (!this.audioHabilitado) {
        this.$swal({
          icon: "warning",
          title: "Audio no disponible",
          text: "El navegador no soporta audio o no se han otorgado permisos",
        });
        return;
      }

      this.sonidoActivo = !this.sonidoActivo;
    },

    // Métodos de mapa
    actualizarMarcadoresMapa() {
      this.markersNovedades = this.novedades
        .filter((novedad) => novedad.latitud && novedad.longitud)
        .map((novedad) => {
          const estaSeleccionada =
            this.novedadSeleccionada &&
            this.novedadSeleccionada.id === novedad.id;
          return {
            position: {
              lat: parseFloat(novedad.latitud),
              lng: parseFloat(novedad.longitud),
            },
            icon: this.getMarkerIcon(novedad.relevancia, estaSeleccionada),
            novedad: novedad,
          };
        });
    },

    getMarkerIcon(relevancia, estaSeleccionada = false) {
      const iconColors = {
        1: "#ffc107", // Amarillo para advertencia
        2: "#dc3545", // Rojo para emergencia
        3: "#17a2b8", // Azul para media relevancia
      };

      const color = iconColors[relevancia] || "#6c757d";

      // Si está seleccionada, resaltar con borde más grueso, escala mayor y color más brillante
      if (estaSeleccionada) {
        return {
          path:
            "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
          fillColor: color,
          fillOpacity: 1,
          strokeColor: "#000000", // Borde negro para destacar
          strokeWeight: 4, // Borde más grueso
          scale: 2.0, // Marcador más grande
          anchor: { x: 12, y: 24 },
        };
      }

      return {
        path:
          "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
        fillColor: color,
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 2,
        scale: 1.5,
        anchor: { x: 12, y: 24 },
      };
    },

    seleccionarNovedad(novedad) {
      this.novedadSeleccionada = novedad;
      if (novedad.latitud && novedad.longitud) {
        this.mapCenter = {
          lat: parseFloat(novedad.latitud),
          lng: parseFloat(novedad.longitud),
        };
        this.mapZoom = 15;
        // Actualizar los marcadores para resaltar el seleccionado
        this.actualizarMarcadoresMapa();
      }
    },

    toggleInfoWindow(marker, index) {
      this.infoWindowPosition = marker.position;
      this.infoWindowContent = this.generarContenidoInfoWindow(marker.novedad);
      this.infoWindowOpen = true;
    },

    escapeHtml(val) {
      if (val == null || val === "") return "";
      return String(val)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    },

    getTipoNovedadMeta(tipo) {
      const map = {
        1: {
          color: "#0891b2",
          gradient: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
          icon: "fa-satellite-dish",
        },
        2: {
          color: "#059669",
          gradient: "linear-gradient(135deg, #059669 0%, #047857 100%)",
          icon: "fa-route",
        },
        4: {
          color: "#2563eb",
          gradient: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
          icon: "fa-draw-polygon",
        },
      };
      return (
        map[tipo] || {
          color: "#64748b",
          gradient: "linear-gradient(135deg, #64748b 0%, #475569 100%)",
          icon: "fa-bell",
        }
      );
    },

    getRelevanciaMeta(relevancia) {
      const map = {
        1: { bg: "#fef3c7", color: "#92400e", border: "#f59e0b" },
        2: { bg: "#fee2e2", color: "#991b1b", border: "#ef4444" },
        3: { bg: "#dbeafe", color: "#1e40af", border: "#3b82f6" },
      };
      return (
        map[relevancia] || {
          bg: "#f1f5f9",
          color: "#475569",
          border: "#94a3b8",
        }
      );
    },

    getProgramacionId(novedad) {
      if (!novedad) return null;
      return (
        (novedad.viaje && novedad.viaje.zafiro_id) ||
        (novedad.det_postulacion && novedad.det_postulacion.zafiro_id) ||
        null
      );
    },

    getReferenciaOperacion(novedad) {
      if (!novedad) return null;
      if (novedad.viaje_id) {
        return { label: "Viaje", value: `#${novedad.viaje_id}` };
      }
      if (novedad.det_postulacion_id) {
        return {
          label: "Postulación",
          value: `#${novedad.det_postulacion_id}`,
        };
      }
      return null;
    },

    getCamposDetallePorTipo(novedad) {
      const campos = [];
      const tipo = parseInt(novedad.tipo_novedad, 10);

      if (novedad.velocidad != null && novedad.velocidad !== "") {
        campos.push({
          icon: "fa-tachometer-alt",
          label: "Velocidad",
          value: `${novedad.velocidad} km/h`,
          highlight: tipo === 1 || tipo === 2,
        });
      }

      if (tipo === 2 && novedad.det_tramo_ruta && novedad.det_tramo_ruta.tramo_ruta) {
        campos.push({
          icon: "fa-road",
          label: "Tramo",
          value: novedad.det_tramo_ruta.tramo_ruta.nombre,
          highlight: true,
        });
      }

      if (tipo === 4 && novedad.direccion) {
        campos.push({
          icon: "fa-map-marked-alt",
          label: "Detalle geocerca",
          value: novedad.direccion,
          highlight: true,
        });
      }

      if (tipo === 1 && novedad.direccion) {
        campos.push({
          icon: "fa-map-marker-alt",
          label: "Ubicación GPS",
          value: novedad.direccion,
        });
      }

      const sitioCargue = this.getSitioCargue(novedad);
      if (sitioCargue && sitioCargue !== "N/A") {
        campos.push({
          icon: "fa-gas-pump",
          label: "Sitio cargue",
          value: sitioCargue,
        });
      }

      const sitioDescargue = this.getSitioDescargue(novedad);
      if (sitioDescargue && sitioDescargue !== "N/A") {
        campos.push({
          icon: "fa-warehouse",
          label: "Sitio descargue",
          value: sitioDescargue,
        });
      }

      return campos;
    },

    renderInfoWindowRow(icon, label, value, options = {}) {
      if (!value || value === "N/A") return "";
      const iconColor = options.iconColor || "#64748b";
      const valueStyle = options.highlight
        ? "font-weight:700;color:#0f172a;"
        : "font-weight:600;color:#1e293b;";
      return `
        <div style="display:flex;align-items:flex-start;gap:10px;margin-bottom:10px;">
          <div style="width:28px;height:28px;border-radius:8px;background:#f8fafc;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
            <i class="fas ${icon}" style="color:${iconColor};font-size:12px;"></i>
          </div>
          <div style="flex:1;min-width:0;">
            <div style="font-size:10px;text-transform:uppercase;letter-spacing:.04em;color:#94a3b8;margin-bottom:2px;">${this.escapeHtml(label)}</div>
            <div style="font-size:13px;line-height:1.35;word-break:break-word;${valueStyle}">${this.escapeHtml(value)}</div>
          </div>
        </div>
      `;
    },

    generarContenidoInfoWindow(novedad) {
      const meta = this.getTipoNovedadMeta(novedad.tipo_novedad);
      const rel = this.getRelevanciaMeta(novedad.relevancia);
      const subNovedad = this.getTipoSubNovedad(novedad) || "N/A";
      const programacion = this.getProgramacionId(novedad);
      const referencia = this.getReferenciaOperacion(novedad);
      const remolque = this.getRemolque(novedad);
      const conductorDoc = this.getConductorDocumento(novedad);
      const conductorCel = this.getConductorCelular(novedad);
      const detalleTipo = this.getCamposDetallePorTipo(novedad);

      let conductorExtra = "";
      if (conductorDoc && conductorDoc !== "N/A") {
        conductorExtra += ` · Doc. ${this.escapeHtml(conductorDoc)}`;
      }
      if (conductorCel && conductorCel !== "N/A") {
        conductorExtra += ` · ${this.escapeHtml(conductorCel)}`;
      }

      const detalleHtml = detalleTipo
        .map((c) =>
          this.renderInfoWindowRow(c.icon, c.label, c.value, {
            iconColor: meta.color,
            highlight: c.highlight,
          })
        )
        .join("");

      const coords =
        novedad.latitud && novedad.longitud
          ? `${parseFloat(novedad.latitud).toFixed(5)}, ${parseFloat(
              novedad.longitud
            ).toFixed(5)}`
          : null;

      return `
        <div style="font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;min-width:300px;max-width:340px;border-radius:12px;overflow:hidden;box-shadow:0 8px 24px rgba(15,23,42,.12);border:1px solid #e2e8f0;">
          <div style="background:${meta.gradient};color:#fff;padding:12px 14px;">
            <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
              <div style="display:flex;align-items:center;gap:8px;min-width:0;">
                <i class="fas ${meta.icon}" style="font-size:16px;opacity:.95;"></i>
                <strong style="font-size:14px;line-height:1.2;">${this.escapeHtml(novedad.nTipoNovedad || "Novedad")}</strong>
              </div>
              <span style="background:${rel.bg};color:${rel.color};border:1px solid ${rel.border};font-size:10px;font-weight:700;padding:3px 8px;border-radius:999px;white-space:nowrap;">
                ${this.escapeHtml(novedad.nRelevancia || "N/A")}
              </span>
            </div>
            <div style="margin-top:8px;display:inline-block;background:rgba(255,255,255,.18);color:#fff;font-size:11px;font-weight:600;padding:4px 10px;border-radius:999px;">
              ${this.escapeHtml(subNovedad)}
            </div>
          </div>

          <div style="padding:12px 14px;background:#fff;">
            ${this.renderInfoWindowRow(
              "fa-truck",
              "Vehículo",
              this.getPlacaVehiculo(novedad),
              { iconColor: meta.color, highlight: true }
            )}
            ${
              remolque
                ? this.renderInfoWindowRow("fa-trailer", "Remolque", remolque, {
                    iconColor: meta.color,
                  })
                : ""
            }
            ${this.renderInfoWindowRow(
              "fa-user",
              "Conductor",
              `${this.getConductor(novedad)}${conductorExtra}`,
              { iconColor: meta.color }
            )}
            ${this.renderInfoWindowRow(
              "fa-building",
              "Transportadora",
              this.getEmpresa(novedad),
              { iconColor: meta.color }
            )}
            ${
              programacion
                ? this.renderInfoWindowRow(
                    "fa-hashtag",
                    "Programación (Zafiro)",
                    programacion,
                    { iconColor: meta.color, highlight: true }
                  )
                : ""
            }
            ${
              referencia
                ? this.renderInfoWindowRow(
                    referencia.label === "Viaje" ? "fa-route" : "fa-file-alt",
                    referencia.label,
                    referencia.value,
                    { iconColor: meta.color }
                  )
                : ""
            }

            ${
              detalleHtml
                ? `<div style="border-top:1px dashed #e2e8f0;margin:4px 0 10px;padding-top:10px;">
                    <div style="font-size:10px;text-transform:uppercase;letter-spacing:.06em;color:#94a3b8;margin-bottom:8px;font-weight:700;">
                      Detalle ${this.escapeHtml(novedad.nTipoNovedad || "")}
                    </div>
                    ${detalleHtml}
                  </div>`
                : ""
            }

            ${this.renderInfoWindowRow(
              "fa-clock",
              "Fecha reporte",
              this.formatFecha(novedad.fecha_novedad),
              { iconColor: "#64748b" }
            )}
            ${
              novedad.nEstado
                ? this.renderInfoWindowRow(
                    "fa-clipboard-check",
                    "Estado gestión",
                    novedad.nEstado,
                    { iconColor: "#64748b" }
                  )
                : ""
            }
            ${
              coords
                ? this.renderInfoWindowRow(
                    "fa-crosshairs",
                    "Coordenadas",
                    coords,
                    { iconColor: "#64748b" }
                  )
                : ""
            }
          </div>
        </div>
      `;
    },

    onMapClick() {
      this.infoWindowOpen = false;
    },

    // Métodos de utilidad
    formatFecha(fecha) {
      return moment(fecha).format("DD/MM/YYYY HH:mm");
    },

    getPlacaVehiculo(novedad) {
      if (!novedad) return "N/A";

      const placaViaje =
        novedad.viaje &&
        novedad.viaje.vehiculo &&
        (novedad.viaje.vehiculo.placa || novedad.viaje.vehiculo.placa_vehiculo);
      if (placaViaje) return placaViaje;

      const placaPostulacion =
        novedad.det_postulacion &&
        novedad.det_postulacion.vehiculo &&
        (novedad.det_postulacion.vehiculo.placa ||
          novedad.det_postulacion.vehiculo.placa_vehiculo);
      if (placaPostulacion) return placaPostulacion;

      const placaVehiculoObj =
        novedad.vehiculo &&
        (novedad.vehiculo.placa || novedad.vehiculo.placa_vehiculo);
      if (placaVehiculoObj) return placaVehiculoObj;

      return novedad.placa_vehiculo || "N/A";
    },

    getConductor(novedad) {
      if (!novedad) return "N/A";

      // Buscar conductor en det_postulacion
      if (novedad.det_postulacion && novedad.det_postulacion.conductor) {
        const conductor = novedad.det_postulacion.conductor;
        if (conductor.nombres && conductor.apellidos) {
          return `${conductor.nombres} ${conductor.apellidos}`;
        }
        if (conductor.nombres) return conductor.nombres;
        if (conductor.apellidos) return conductor.apellidos;
      }

      // Buscar conductor en viaje
      if (novedad.viaje && novedad.viaje.conductor) {
        const conductor = novedad.viaje.conductor;
        if (conductor.nombres && conductor.apellidos) {
          return `${conductor.nombres} ${conductor.apellidos}`;
        }
        if (conductor.nombres) return conductor.nombres;
        if (conductor.apellidos) return conductor.apellidos;
      }

      // Buscar conductor directo
      if (novedad.conductor) {
        const conductor = novedad.conductor;
        if (conductor.nombres && conductor.apellidos) {
          return `${conductor.nombres} ${conductor.apellidos}`;
        }
        if (conductor.nombres) return conductor.nombres;
        if (conductor.apellidos) return conductor.apellidos;
      }

      return "N/A";
    },

    getConductorDocumento(novedad) {
      if (!novedad) return "N/A";

      // Buscar documento en det_postulacion
      if (novedad.viaje && novedad.viaje.conductor) {
        const conductor = novedad.viaje.conductor;
        if (conductor.numero_documento) {
          return conductor.numero_documento;
        }
      }

      // Buscar documento en viaje
      if (novedad.viaje && novedad.viaje.conductor) {
        const conductor = novedad.viaje.conductor;
        if (conductor.numero_documento) {
          return conductor.numero_documento;
        }
      }

      // Buscar documento directo
      if (novedad.conductor && novedad.conductor.numero_documento) {
        return novedad.conductor.numero_documento;
      }

      return "N/A";
    },

    getConductorCelular(novedad) {
      if (!novedad) return "N/A";

      // Buscar celular en det_postulacion
      if (novedad.det_postulacion && novedad.det_postulacion.conductor) {
        const conductor = novedad.det_postulacion.conductor;
        if (conductor.celular_principal) {
          return conductor.celular_principal;
        }
      }

      // Buscar celular en viaje
      if (novedad.viaje && novedad.viaje.conductor) {
        const conductor = novedad.viaje.conductor;
        if (conductor.celular_principal) {
          return conductor.celular_principal;
        }
      }

      // Buscar celular directo
      if (novedad.conductor && novedad.conductor.celular_principal) {
        return novedad.conductor.celular_principal;
      }

      return "N/A";
    },

    getRemolque(novedad) {
      if (!novedad) return null;

      const placaViaje =
        novedad.viaje &&
        novedad.viaje.remolque &&
        (novedad.viaje.remolque.placa || novedad.viaje.remolque.placa_remolque);
      if (placaViaje) return placaViaje;

      const placaPost =
        novedad.det_postulacion &&
        novedad.det_postulacion.remolque &&
        (novedad.det_postulacion.remolque.placa ||
          novedad.det_postulacion.remolque.placa_remolque);
      if (placaPost) return placaPost;

      const placaRemolqueObj =
        novedad.remolque &&
        (novedad.remolque.placa || novedad.remolque.placa_remolque);
      if (placaRemolqueObj) return placaRemolqueObj;

      return novedad.placa_remolque || null;
    },

    getEmpresa(novedad) {
      if (!novedad) return "Sin transportadora";
      return (
        (novedad.viaje &&
          novedad.viaje.transportadora &&
          novedad.viaje.transportadora.razon_social) ||
        (novedad.det_postulacion &&
          novedad.det_postulacion.det_solicitud_diaria &&
          novedad.det_postulacion.det_solicitud_diaria.empresa &&
          novedad.det_postulacion.det_solicitud_diaria.empresa.razon_social) ||
        "Sin transportadora"
      );
    },

    getTipoSubNovedad(novedad) {
      if (!novedad) return null;

      switch (novedad.tipo_novedad) {
        case 1:
          return novedad.nSubNovedadGps;
        case 2:
          return novedad.nSubNovedadRuta;
        case 4:
          return novedad.nSubNovedadGeocerca;
      }
      return null;
    },

    getSitioCargue(novedad) {
      if (novedad.viaje) {
        const sitio =
          novedad.viaje.sitioCargue || novedad.viaje.sitio_cargue;
        if (sitio && sitio.nombre) return sitio.nombre;
      }

      if (
        novedad.det_postulacion &&
        novedad.det_postulacion.det_solicitud_diaria &&
        novedad.det_postulacion.det_solicitud_diaria.solicitud_diaria &&
        novedad.det_postulacion.det_solicitud_diaria.solicitud_diaria.sitio
      ) {
        return novedad.det_postulacion.det_solicitud_diaria.solicitud_diaria
          .sitio.nombre;
      }

      return "N/A";
    },

    getSitioDescargue(novedad) {
      if (novedad.viaje) {
        const sitio =
          novedad.viaje.sitioDescargue || novedad.viaje.sitio_descargue;
        if (sitio && sitio.nombre) return sitio.nombre;
      }

      if (
        novedad.det_postulacion &&
        novedad.det_postulacion.det_solicitud_diaria &&
        novedad.det_postulacion.det_solicitud_diaria.sitio_destino
      ) {
        return novedad.det_postulacion.det_solicitud_diaria.sitio_destino
          .nombre;
      }

      return "N/A";
    },

    getEstadoNovedad(novedad) {
      return novedad.estado_gestion || "Sin gestionar";
    },

    getNovedadIcon(tipoNovedad) {
      const iconos = {
        1: "fa-exclamation-triangle", // Advertencia
        2: "fa-exclamation-circle", // Emergencia
        3: "fa-info-circle", // Información
      };
      return iconos[tipoNovedad] || "fa-bell";
    },

    getRelevanciaButtonClass(relevancia) {
      const clases = {
        1: "btn-warning",
        2: "btn-danger",
        3: "btn-info",
      };
      return clases[relevancia] || "btn-secondary";
    },

    getRelevanciaColor(relevancia) {
      const colores = {
        1: "bg-warning",
        2: "bg-danger",
        3: "bg-info",
      };
      return colores[relevancia] || "bg-secondary";
    },

    // Métodos de exportación
    abrirModalExportar() {
      // Inicializar filtros de exportación con valores por defecto
      this.filtrosExportar = {
        fecha_inicial: moment()
          .subtract(7, "days")
          .format("YYYY-MM-DD"),
        fecha_final: moment().format("YYYY-MM-DD"),
        tipo_novedad: null,
        relevancia: null,
      };

      // Mostrar modal
      const modalElement = document.getElementById("modalExportar");
      if (modalElement) {
        const modal = new window.bootstrap.Modal(modalElement);
        modal.show();
      }
    },

    exportarNovedades() {
      this.exportando = true;
      const params = {
        ...this.filtrosExportar,
      };
      axios({
        method: "GET",
        url: "/api/admin/centralTrafico/exportarNovedades",
        params,
      })
        .then((response) => {
          this.exportando = false;
          let data = response.data;
          if (data.success) {
            this.$refs.modalExportar.click();
            location.href = data.url;
            this.$swal({
              icon: "success",
              title: data.message,
              text: "El archivo se ha descargado correctamente",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          } else {
            this.$swal({
              icon: "error",
              title: data.message,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
          this.exportando = false;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error: " + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.exportando = false;
        });
    },

    valFechasExportar() {
      let fechaInicial = moment(this.filtrosExportar.fecha_inicial);
      let fechaFinal = moment(this.filtrosExportar.fecha_final);
      if (
        this.filtrosExportar.fecha_inicial &&
        this.filtrosExportar.fecha_final
      ) {
        if (fechaInicial.isAfter(fechaFinal)) {
          this.$swal({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            icon: "error",
            title: "La fecha inicial no puede ser mayor a la fecha final",
          });
          this.filtrosExportar.fecha_final = null;
        }
      }
    },
  },
};
</script>
